import { pocketsLookAheadContainer } from '../../views/pockets/pockets-look-ahead/pockets-look-ahead-container';

import { squarePanelFromRecommendationsBestPerformingArticles } from './best-performing-articles/square-panel-best-performing-articles';
import { squarePanelFromRecommendationsBestPerformingArticlesGlobal } from './best-performing-articles/square-panel-best-performing-articles-global';
import { createHorizontalScrollablePanelBoughtThisSeason } from './bought-this-season/horizontal-scrollable-panel-bought-this-season';
import { horizontalScrollablePanelProductsOnTheWay } from './horizontal-products-on-the-way/horizontal-products-on-the-way';
import { horizontalScrollablePanelFromList } from './horizontal-scrollable-panel-from-list';
import { horizontalScrollablePanelPBasketSearch } from './p-basket-search/horizontal-scrollable-p-basket-search-panel';
import { panelFromListRoot } from './panel-from-list';
import { pillsNavigation } from './pills-navigation';
import { squarePanelFromRecommendationsProductsOnTheWay } from './products-on-the-way/square-panel-products-on-the-way';
import { searchBarBasePanel } from './search-bar-base-panel';
import { searchBarPanel } from './search-bar-panel';
import { slidingCarouselPanel } from './sliding-carousel/sliding-carousel-panel';
import { squarePanelFromList } from './square-panel-from-list';
import { squarePanelFromListSingleProduct } from './square-panel-from-list-single-product';
import { squarePanelFromSearch } from './square-panel-from-search';
import { userFeedbackPanel } from './user-feedback/user-feedback-panel.config';

export const common = {
  horizontalScrollablePanelPBasketSearch,
  horizontalScrollablePanelFromList,
  panelFromListRoot,
  squarePanelFromList,
  squarePanelFromListSingleProduct,
  squarePanelFromRecommendationsBestPerformingArticles,
  squarePanelFromRecommendationsBestPerformingArticlesGlobal,
  squarePanelFromRecommendationsProductsOnTheWay,
  horizontalScrollablePanelBoughtThisSeason:
    createHorizontalScrollablePanelBoughtThisSeason(),
  searchBarBasePanel,
  searchBarPanel,
  squarePanelFromSearch,
  slidingCarouselPanel,
  pocketsLookAheadContainer,
  pillsNavigation,
  horizontalScrollablePanelProductsOnTheWay,
  userFeedbackPanel,
};

export * from './bought-this-season/horizontal-scrollable-panel-bought-this-season';
